export default function LogoFooter({ variant = "default" }) {
  const logoSrc =
    variant === "white"
      ? process.env.REACT_APP_ROOT_FOLDER + "/prefWhite.png"
      : process.env.REACT_APP_ROOT_FOLDER + "/pmsp.png";

  return (
    <div className="flex justify-end gap-8 ">
      <img src={logoSrc} alt="Logo" className=" object-contain" width={270} />
    </div>
  );
}
